module.exports = __webpack_public_path__ + "img/starting.1a54b888.gif";